package games.polyclub.website.frontend.store.layout

import games.polyclub.frontend.lib.messagerenderer.m
import games.polyclub.frontend.lib.react.simplified.SFC
import games.polyclub.frontend.lib.react.simplified.tags.*
import games.polyclub.message.div
import games.polyclub.message.unaryMinus
import games.polyclub.website.frontend.store.hooks.useAuth
import games.polyclub.website.frontend.store.sitemap.LoggedSitemap
import react.Props
import react.router.dom.Link
import web.window.WindowTarget

val TopBarLinks = SFC<Props> { _ ->
    val authCtx = useAuth()
    ul("navbar-nav") {
        PushMenu()
        li("nav-item d-none d-sm-inline-block") {
            Link("nav-link") {
                to = "/"
                +"Início"
            }
        }
        li("nav-item d-none d-sm-inline-block") {
            Link("nav-link") {
                to = LoggedSitemap.HOME.path
                m(-"Área ${"da"/authCtx.auth} Cliente")
            }
        }
        li("nav-item d-none d-sm-inline-block") {
            a("nav-link") {
                href = "https://forum.gamemods.com.br"
                target = WindowTarget._blank
                +"Fórum GameMods"
            }
        }
        li("nav-item d-none d-sm-inline-block") {
            a("nav-link") {
                href = "https://discord.gg/E9rK39X"
                target = WindowTarget._blank
                +"Discord: GameMods"
            }
        }
        li("nav-item d-none d-sm-inline-block") {
            a("nav-link") {
                href = "https://discord.gg/jMnvwt4EuC"
                target = WindowTarget._blank
                +"Discord: Cantinho da Poly"
            }
        }
        li("nav-item d-none d-sm-inline-block") {
            a("nav-link") {
                href = "https://linktr.ee/PolyanaGM"
                target = WindowTarget._blank
                +"Redes Sociais da Poly"
            }
        }
    }
}
